// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bdMain {
  background: #1d1a36;
}

.bdKey {
  display: flex;
  justify-content: center;
  width: 100%;
}

.bdCenter {
  display: flex;
  justify-content: center;
}

.bdTextCenter {
  text-align: center;
}

.bdBlueOrangeGrad {
  border-radius: 1.4vh;
  background: linear-gradient(45deg, rgb(255, 182, 160), rgb(240, 89, 42), rgb(37, 60, 119)) !important;
  padding: 2px !important;
  margin-bottom: 4.2vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bdBlueOrangeGrad span {
  color: #fff;
  border-radius: 1.5vh;
  background: #1d1a36 !important;
  font-size: 1.5vw;
  padding: 2vh;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1024px) {
  .bdBlueOrangeGrad span {
    font-size: 1.15rem;
  }
}

.bdLeftTextRow1 {
  display: flex;
  justify-content: center;
  width: 100%;
}

.bdLeftTexth3 {
  text-align: center;
}

.bdLeftBrace {
  width: 2%;
  align-items: flex-start;
}
@media (max-width: 768px) {
  .bdLeftBrace {
    width: 6%;
  }
}

.bdRightBrace {
  width: 2%;
  align-items: flex-end;
}
@media (max-width: 768px) {
  .bdRightBrace {
    width: 6%;
  }
}

.bdLeftTextCont {
  font-size: 3vh;
  font-weight: 400;
  color: rgb(240, 89, 42);
  width: 60%;
  text-align: center;
}
@media (max-width: 1024px) {
  .bdLeftTextCont {
    font-size: 1.15rem;
    width: 80%;
  }
}

.bdKeyBenefits {
  position: relative;
}

.bdGradient {
  width: 50vw;
  height: 84vh;
  flex-shrink: 0;
  position: absolute;
  left: 0;
  z-index: 0;
  border-radius: 100%;
  opacity: 0.6;
  background: var(--orange-4, rgba(240, 89, 42, 0.4));
  filter: blur(150px);
}`, "",{"version":3,"sources":["webpack://./src/Pages/BigData/bigData.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,qGAAA;EAMA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAKE;EAVF;IAWI,kBAAA;EAFF;AACF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,SAAA;EACA,uBAAA;AAFF;AAGE;EAHF;IAII,SAAA;EAAF;AACF;;AAGA;EACE,SAAA;EACA,qBAAA;AAAF;AACE;EAHF;IAII,SAAA;EAEF;AACF;;AACA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AAEF;AADE;EANF;IAOI,kBAAA;IACA,UAAA;EAIF;AACF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,mDAAA;EACA,mBAAA;AAIF","sourcesContent":[".bdMain {\n  background: #1d1a36;\n}\n\n.bdKey {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.bdCenter {\n  display: flex;\n  justify-content: center;\n}\n\n.bdTextCenter {\n  text-align: center;\n}\n\n.bdBlueOrangeGrad {\n  border-radius: 1.4vh;\n  background: linear-gradient(\n    45deg,\n    rgba(255, 182, 160, 1),\n    rgba(240, 89, 42, 1),\n    rgba(37, 60, 119, 1)\n  ) !important;\n  padding: 2px !important;\n  margin-bottom: 4.2vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bdBlueOrangeGrad span {\n  color: #fff;\n  border-radius: 1.5vh;\n  background: #1d1a36 !important;\n  font-size: 1.5vw;\n  padding: 2vh;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: 1024px) {\n    font-size: 1.15rem;\n  }\n}\n\n.bdLeftTextRow1 {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.bdLeftTexth3 {\n  text-align: center;\n}\n\n.bdLeftBrace {\n  width: 2%;\n  align-items: flex-start;\n  @media (max-width: 768px) {\n    width: 6%;\n  }\n}\n\n.bdRightBrace {\n  width: 2%;\n  align-items: flex-end;\n  @media (max-width: 768px) {\n    width: 6%;\n  }\n}\n\n.bdLeftTextCont {\n  font-size: 3vh;\n  font-weight: 400;\n  color: rgba(240, 89, 42, 1);\n  width: 60%;\n  text-align: center;\n  @media (max-width: 1024px) {\n    font-size: 1.15rem;\n    width: 80%;\n  }\n}\n\n.bdKeyBenefits {\n  position: relative;\n}\n\n.bdGradient {\n  width: 50vw;\n  height: 84vh;\n  flex-shrink: 0;\n  position: absolute;\n  left: 0;\n  z-index: 0;\n  border-radius: 100%;\n  opacity: 0.6;\n  background: var(--orange-4, rgba(240, 89, 42, 0.4));\n  filter: blur(150px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
